// ----------------------------------------------------------------------
// <copyright file="Izenda.PerformanceAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var mobx = require('mobx');
  var React = require('react');
  var compose = require('recompose').compose;
  var withState = require('recompose').withState;
  var withHandlers = require('recompose').withHandlers;

  var commonMessages = require('share/messages/Izenda.CommonMessages');
  const { curry, isEmpty } = require('lodash/fp');
  var PerformanceAction = compose(
    withHandlers({
      onSave: curry(onSave),
      onCancel: curry(onCancel)
    })
  );

  function onCancel(props, _) {
    var store = props.store;
    var localization = props.localization;

    if (store.performanceModel.isDirty) {
      props
        .confirmFn('Confirmation', {
          description: localization.getText('COMMON_MESSAGES_CONFIRM_CHANGES_LOST')
        })
        .then(loadInitalData.bind(null, props));
    }
  }

  function loadInitalData(props) {
    var loader = props.loader;
    var store = props.store;

    props.validation.reset();

    loader.startLoading();
    store.getInitial().finally(loader.endLoading.bind(loader));
  }

  function onSave(props, e) {
    var store = props.store;
    var loader = props.loader;
    var performanceModel = store.performanceModel;
    var valManager = props.validation;
    var localization = props.localization;

    performanceModel.alertMessage = commonMessages.EMPTY_MESSAGE;
    loader.startLoading();

    return valManager
      .validate()
      .then(
        function(success) {
          if (success && !performanceModel.isDirty) {
            performanceModel.alertMessage = {
              type: 'info',
              message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
            };
          } else if (success) {
            return props
              .confirmFn('Confirmation', {
                description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
              })
              .then(store.onSave.bind(store));
          }
          return null;
        }.bind(this)
      )
      .then(function(saveErrors) {
        if (!isEmpty(saveErrors)) {
          valManager.updateErrors(saveErrors);
        }
        return null;
      })
      .finally(loader.endLoading.bind(loader));
  }

  module.exports = PerformanceAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Izenda.PerformanceAction.js